<template>

  <div id="app">
    <nav class="topMenu pc">
      <router-link to="/" class="topMenuItem">Home</router-link>
      <router-link to="/game" class="topMenuItem">Game</router-link>
      <router-link to="/illust" class="topMenuItem">Illust</router-link>
      <router-link to="/music" class="topMenuItem">Music</router-link>
      <router-link to="/novel" class="topMenuItem">Novel</router-link>
      <a href="https://qpic.jp/" class="toQpicLink"></a>
    </nav>
    <header class="sp">
      <div class="menu-button sp" v-on:click="hamburgerMenuClicked">
        <span ref="line"></span>
      </div>
      <nav class="topMenu sp" ref="menu">
        <router-link to="/" class="topMenuItem" v-on:click.native="hamburgerMenuClicked">Home</router-link>
        <router-link to="/game" class="topMenuItem" v-on:click.native="hamburgerMenuClicked">Game</router-link>
        <router-link to="/illust" class="topMenuItem" v-on:click.native="hamburgerMenuClicked">Illust</router-link>
        <router-link to="/music" class="topMenuItem" v-on:click.native="hamburgerMenuClicked">Music</router-link>
        <router-link to="/novel" class="topMenuItem" v-on:click.native="hamburgerMenuClicked">Novel</router-link>
        <a href="https://qpic.jp/" class="toQpicLink">Qpic</a>
      </nav>
      <router-link to="/" class="qfes-logo"></router-link>
    </header>
    <router-view class="content"></router-view>
    <router-link to="/" class="qfes-logo pc"></router-link>
  </div>
</template>

<script>

export default {
  name: 'App',
  methods:{
    hamburgerMenuClicked:function(){
      this.$refs.line.classList.toggle('active');
      this.$refs.menu.classList.toggle('active');
    }
  }
}
</script>

<style scoped>
/*共通デザイン*/
body{
  margin: 0;
  padding: 0;
}

/*スマートフォン向けデザイン*/
header{
  background-color: rgb(246,246,233);
  width: 100%;
  height: 65px;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  position: fixed;
}

.menu-button{
  width: 65px;
  height: 65px;
  position: absolute;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
}

.menu-button span, .menu-button span:before, .menu-button span:after{
  content: '';
  display: block;
  height: 3px;
  width: 30px;
  border-radius: 3px;
  background-color: black;
  position: absolute;
  transition: all .4s;
}

.menu-button span:before{
  bottom: 8px;
}

.menu-button span:after{
  top: 8px;
}

.menu-button span.active{
  background-color: rgba(255,255,255,0);
}

.menu-button span.active:before{
  bottom: 0;
  transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
}

.menu-button span.active:after{
  top: 0;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
}

.topMenu.sp{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 100%;
  background-color: rgb(246,246,233);
  z-index: 40;
  transition: all .4s;
}

.topMenu.sp.active{
  left: 0;
}

.topMenu.sp:first-child{
  border-top: solid rgb(251,251,238);
}

.topMenu.sp > .topMenuItem{
  border-bottom: solid rgb(251,251,238);
  width: 100%;
  margin: 0;
  padding: 0;
  font-size: 3.0em;
  display: inline-block;
  text-align: center;
  text-decoration: none;
  color: black;
  position: relative;
  top: 65px;
}

.content{
  height : calc(100vh - 65px);
  top: 65px;
  position: fixed;
  width: 100%;
  padding: 0;
  margin: 0;
  background-repeat: no-repeat;
  background-position: 50% 100%;
  background-size: auto 100%;
  z-index: -20;
}

.qfes-logo{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  width: 70px;
  height: 50px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url('assets/logo.png');
}

.toQpicLink{
  width: 100%;
  font-size: 3.0em;
  position: relative;
  display: inline-block;
  text-align: center;
  justify-content: center;
  background-image: url('assets/qpic_logo.svg');
  background-size: auto 90%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  top: 65px;
  color: rgba(246,246,233,0);
  border-bottom: solid rgb(251,251,238);
  margin: 0;
  padding: 0;
  font-size: 3.0em;
}

.pc{
  display: none;
}

/*PC・タブレット向けデザイン*/
@media screen and (min-width:600px){
}

/*PC向けデザイン*/
@media screen and (min-width:1280px){
#app {
  /*#font-family: Avenir, Helvetica, Arial, sans-serif;
  #-webkit-font-smoothing: antialiased;
  #-moz-osx-font-smoothing: grayscale;
  #text-align: center;
  #color: #2c3e50;*/
}

.topMenu{
  background-color: rgb(246,246,233);
  height: 80px;
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
}

.topMenuItem{
  flex : 2;
  height: 100%;
  font-size: 50px;
  display: block;
  text-align: center;
  justify-content: center;
  text-decoration: none;
  color: black;
}

.toQpicLink{
  flex : 1;
  height: 100%;
  width: auto;
  display: block;
  text-align: center;
  justify-content: center;
  text-decoration: none;
  background-image: url('assets/qpic_logo.svg');
  background-size: 50% auto;
  background-repeat: no-repeat;
  background-position: right 10px bottom 10px;
  background-color: transparent;
  border: 0px none rgba(0,0,0,0);
  top:0;
}

.topMenuItemToRoot{
  flex: 1;
  height: 100%;
  display: block;
  padding: 0;
}

.topMenuItemToRoot img{
  max-height: 95%;
  max-width: 90%;
  margin: auto;
  padding: 0;
  display: block;
}

.content{
  height : calc(100vh - 80px);
  width: 100%;
  padding: 0;
  margin: 0;
  top: 80px;
  position: fixed;
  background-repeat: no-repeat;
  background-position: 50% 100%;
  background-size: 100% 100%;
}

  .qfes-logo{
    position: absolute;
    right: 10px;
    bottom: 10px;
    top: auto;
    left: auto;
    transform: none;
    background-image: url('assets/logo.png');
    background-size: 100% 100%;
    height: calc(calc(calc(100vw / 10) - 20px) * 0.67);
    width: calc(calc(100vw / 10) - 20px) ;
    display: block;
    z-index: 1000;
  }

  
}

/*スマートフォンデザイン非表示*/
@media screen and (min-width: 1280px){
  .sp{
    display: none;
  }
}
</style>
